<template>
    <div>
        <page-title>编辑版本信息</page-title>
        <page-body>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form">
                <el-form-item label="版本号" prop="version">
                    <el-input v-model="form.version" placeholder=""/>
                </el-form-item>
                <el-form-item label="更新代码包" prop="src_file">
                    <el-input v-model="form.src_file" placeholder="">
                        <div slot="append">
                            <el-upload :action="uploadServer"
                                       :headers="uploadHeaders"
                                       :show-file-list="false"
                                       :before-upload="beforeUploadSrcFile"
                                       :on-error="uploadSrcFileError"
                                       :on-success="uploadSrcFileSuccess">
                                <el-button :loading="uploadingSrcFile" icon="el-icon-upload"></el-button>
                            </el-upload>
                        </div>
                    </el-input>
                </el-form-item>
                <el-form-item label="数据库脚本" prop="db_file">
                    <el-input v-model="form.db_file" placeholder="">
                        <div slot="append">
                            <el-upload :action="uploadServer"
                                       :headers="uploadHeaders"
                                       :show-file-list="false"
                                       :before-upload="beforeUploadDbFile"
                                       :on-error="uploadDbFileError"
                                       :on-success="uploadDbFileSuccess">
                                <el-button :loading="uploadingDbFile" icon="el-icon-upload"></el-button>
                            </el-upload>
                        </div>
                    </el-input>
                </el-form-item>
                <el-form-item label="更新内容" prop="content">
                    <div>&nbsp;</div>
                    <quill-editor v-model="form.content"></quill-editor>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">{{form.id ? '保存' : '发布'}}
                    </el-button>
                </el-form-item>
            </el-form>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'
import baseUrl from '@/base-url'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'

export default {
    components: {
        quillEditor
    },
    data() {
        return {
            uploadServer: baseUrl + '/admin/upload/file',
            uploadHeaders: null,
            loading: false,
            btnLoading: false,
            detail: null,
            uploadingSrcFile: false,
            uploadingDbFile: false,
            rules: {
                version: [
                    {required: true, message: '填写版本号。'}
                ],
                src_file: [
                    {required: true, message: '填上传更新代码包。'}
                ],
                db_file: [
                    {required: true, message: '填上传数据库脚本。'}
                ],
                content: [
                    {required: true, message: '填写更新内容。'}
                ]
            },
            form: {
                id: null,
                version: '',
                src_file: '',
                db_file: '',
                content: ''
            }
        }
    },
    created() {
        this.uploadHeaders = {
            'Access-Token': this.$store.state.user.access_token
        }
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id
            this.loadData()
        }
    },
    methods: {
        loadData() {
            this.loading = true
            axios({
                url: 'admin/version/detail',
                params: {
                    id: this.form.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.form = e.data.data
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        beforeUploadSrcFile() {
            this.uploadingSrcFile = true
        },
        uploadSrcFileError(err, file, fileList) {
            this.uploadingSrcFile = false
            this.$message.error('文件上传失败。')
            console.log(err)
        },
        uploadSrcFileSuccess(response, file, fileList) {
            this.uploadingSrcFile = false
            if (response.code === 0) {
                this.form.src_file = response.data.url
            } else {
                this.$message.error(response.msg)
            }
        },
        beforeUploadDbFile() {
            this.uploadingDbFile = true
        },
        uploadDbFileError(err, file, fileList) {
            this.uploadingDbFile = false
            this.$message.error('文件上传失败。')
            console.log(err)
        },
        uploadDbFileSuccess(response, file, fileList) {
            this.uploadingDbFile = false
            if (response.code === 0) {
                this.form.db_file = response.data.url
            } else {
                this.$message.error(response.msg)
            }
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    axios({
                        url: 'admin/version/edit',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.push('/dashboard/admin/version/index')
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        }
    }
}
</script>
